<template>
    <div>
        <div v-if="edar" class="hero" style="padding-top: 0.5em;">
            <div class="hero-head has-text-centered">
                <h1 class="title is-1">Live View: {{edar.name}}</h1>
            </div>
            <div class="hero-body" style="padding-bottom: 0">
                <viewer :edar="edar"></viewer>
            </div>
        </div>
    </div>
</template>

<script>
    import Viewer from "../../../components/Viewer";
    export default {
        name: "LiveView",
        components: {Viewer},
        props: {
            edarId: {
                type: [String, Number],
                required: true,
            },
        },
        computed: {
            //Pull the specific EDAR we're interested in out of the store
            edar: function () {
                return this.$store.getters['edar/byId'](this.edarId);
            },
        },
        beforeRouteEnter(to, from, next){
            let edar = window.app.$store.getters['edar/byId'](to.params.edarId);
            to.meta.breadcrumb = `${edar} Live View`;
            next();
        },
        beforeRouteUpdate(to, from, next){
            let edar = this.$store.getters['edar/byId'](to.params.edarId);
            to.meta.breadcrumb = `${edar} Live View`;
            next();
        },
    }
</script>

<style scoped>

</style>